import React, { useState } from 'react';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { useParams } from 'react-router-dom';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
const RequestItemMenu = ({
  status,
  ids,
  onSuccess
}: {
  status: ENUM_REQUEST_STATUS;
  ids: string;
  onSuccess?: () => void;
}) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const receiveItem = async (ids: string) => {
    setLoading(true);
    try {
      await apiService.put(`kitchen-store/requests/${id}/confirm`, {
        version: 'v2',
        data: {
          request_item_ids: [ids]
        }
      });
      toast(<ToastMessage type='success' message='Item received' />);
      if (onSuccess) onSuccess();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const cancelItem = async (ids: string) => {
    setLoading(true);
    try {
      await apiService.put(`kitchen-store/requests/${id}/cancel`, {
        version: 'v2',

        data: {
          request_item_ids: [ids]
        }
      });
      toast(<ToastMessage type='success' message='Item received' />);
      if (onSuccess) onSuccess();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  const menuOptions: Partial<
    Record<ENUM_REQUEST_STATUS, { label: string; onClick: (arg0: string) => void }[]>
  > = {
    [ENUM_REQUEST_STATUS.SENT]: [
      {
        label: 'Item received',
        onClick: receiveItem
      },

      {
        label: 'Item not received',
        onClick: cancelItem
      }
    ],
    [ENUM_REQUEST_STATUS.RECEIVED]: [
      {
        label: 'Receive Item',
        onClick: receiveItem
      }
    ],
    [ENUM_REQUEST_STATUS.COMPLETED]: [
      {
        label: 'Cancel Item',
        onClick: cancelItem
      }
    ]
  };
  return (
    <div className='flex gap-2'>
      {menuOptions[status]?.map((item, index) => (
        <button
          key={index}
          disabled={loading}
          className='w-fit text-xs px-4 py-2 bg-red-5 text-white rounded-md'
          onClick={() => item.onClick(ids)}>
          {loading ? 'Submitting' : item.label}
        </button>
      ))}
    </div>
  );
};

export default RequestItemMenu;
